<template>
  <div>
    
    <br />
    <b-form>
    <h1>Edit Location</h1>
    <b-form-group horizontal label="Name:" label-size="lg">
      <!-- <label for="txtLocationName">Name:</label> -->
      <b-form-input type="text" v-model="location.name"></b-form-input>
    </b-form-group>
    <b-form-group horizontal label="Survey Date:" label-size="lg">
      <b-form-input type="date" v-model="location.surveyDate"></b-form-input>
    </b-form-group>
    <b-form-group horizontal label="Pass Code:" label-size="lg">
      <b-form-input type="text" v-model="location.passCode"></b-form-input>
    </b-form-group>
    <div>
      <b-button variant="primary" size="lg" @click="save">Save</b-button>&nbsp;
      <b-button size="lg" to="/locations" tag="button">Back</b-button>
    </div>
    </b-form>
  </div>
</template>

<script>
import  ajax  from "@/resources/myApi.js";
import Vue from 'vue';
import { moment } from "vue-moment";
export default {
  name: "editLocation",
  data: () => ({
    location: {
      id: null,
      name: "",
      passCode: "",
      surveyDate: "",
      dateCreated: null
    }
    
  }),
  methods: {
    loadLocation(id) {
      ajax
        .get("locations/" + id, 
         { transformResponse: [
          (data) => {
              let resp;
              try {
                resp = JSON.parse(data);
                var surveyDate = new Date(resp.surveyDate);
                resp.surveyDate = surveyDate.toISOString().substr(0, 10);
              } catch (error) {
                throw Error(`[requestClient] Error parsing response JSON data - ${JSON.stringify(error)}`)
              }

              return resp;
    }
  ]}
        )
        .then(result => this.location = result.data)
        .catch(error => console.log(error));
    },
    save() {
      console.log(this.location);
      ajax
        .post("locations/", this.location)
        .then(() => {
          console.log("success");
          window.history.back();
        }
        )
        .catch(error => console.log(error));
    }
  },
  mounted() {
    this.loadLocation(this.$route.params.id);
  }

  
};
</script>
